<template>
  <div v-if="isLoaded && isVisible" class="component-container">
    <div class="band-title-wrap">
      <h3 class="component-title" tabindex="0">{{ title }}</h3>
      <CatalogViewMoreButton :section-info="sectionInfo" />
    </div>

    <CellListEditorPick v-if="hasCellList" :cell-list="cellList" />

    <!--    route / my -->
    <div v-else-if="!hasCellList && isRouteMy" class="component-container">
      <div class="my-no-data">
        <EmptyIcon />
        <span class="my-no-data-txt"> {{ title }} 이 없어요 </span>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { defineProps, ref, computed } from 'vue'
  import { convertBand } from '@/common/converter/convert-band'
  import { useRoute } from 'vue-router/composables'
  import { getBandTypeInfoByCellType } from '@/common/image.util'
  import { getCellType } from '@/common/util/home/get-cell-type'
  import EmptyIcon from '@/assets/svg/common/img_empty.svg'
  import CellListEditorPick from '@/components/section/template/cell/CellListEditorPick'
  import CatalogViewMoreButton from '@/components/view-more/CatalogViewMoreButton.vue'

  const props = defineProps({
    sectionInfo: {
      type: Object,
      default: () => {},
    },
    catalogInfo: {
      type: Object,
      default: () => {},
    },
  })

  const route = useRoute()

  const band = ref({})
  const cellList = ref([])
  const isLoaded = ref(false)
  const isVisible = ref(true)

  const cellType = computed(() => getCellType(props.catalogInfo?.elementList))
  const hasCellList = computed(() => cellList.value.length > 0)
  const title = computed(() => props.sectionInfo?.title ?? '')
  const thumbnailInfo = computed(() =>
    getBandTypeInfoByCellType(cellType.value),
  )
  const isRouteMy = computed(() => route?.name === 'my')

  const setData = async () => {
    try {
      band.value = await convertBand(props.catalogInfo)
      cellList.value = band.value?.band.celllist ?? []
      isLoaded.value = true
    } catch (error) {
      console.error(error)
    }
  }

  const init = () => {
    setData()
  }

  init()
</script>
